import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router';
import useLocalStorage from './useLocalStorage';

export const SIGNUP_PROMO_CODE_KEY = 'signupPromoCode';

export const usePromoCode = () => {
  const [searchParams] = useSearchParams();
  const [storedPromoCode, setStoredPromoCode] = useLocalStorage<string | null>(SIGNUP_PROMO_CODE_KEY, null);

  const promoCodeFromUrl = searchParams.get('code')?.trim() || null;

  const promoCode = useMemo(() => promoCodeFromUrl || storedPromoCode, [promoCodeFromUrl, storedPromoCode]);

  const savePromoCode = useCallback(
    (code: string) => {
      setStoredPromoCode(code);
    },
    [setStoredPromoCode]
  );

  const clearPromoCode = useCallback(() => {
    setStoredPromoCode(null);
  }, [setStoredPromoCode]);

  return {
    promoCode,
    promoCodeFromUrl,
    savePromoCode,
    clearPromoCode,
  };
};
